<template>
	<div class="toggle-buttons" >
		<btn v-for="(item, index) in items" :key="index" :label="item.label" :t="type" s="m" :active="active == item.value" @press="change(index, item.value)"/>
	</div>
</template>
<script>
	import Btn from "../button.vue";
	export default {
		name:"toggle-btns",
		props:{
			items:Array,
			active:[String, Number],
			type:{type:String, default:'p'},
		},
		components:{Btn},
		methods:{
			change(index, value){
				this.$emit("input", value);
			}
		}
	}
</script>
<style scoped>
	.toggle-buttons{
		font-size:24px;
		color:red;
	}
</style>